import { ReactElement } from "react";

import DropdownMenuItem from "ds/components/DropdownMenu/Item";

import TableHeadInteractiveColumnOptionsDropdown from "./Options";
import { COLUMN_CHANGED_ANALYTIC_EVENT } from "./constants";
import { TableHeadInteractiveColumnProps } from ".";
import { TableColumnsState } from "../../hooks/useTableStore/types";

type TableHeadInteractiveColumnActionsDropdownProps = Pick<
  TableHeadInteractiveColumnProps,
  "column" | "stickyLeft" | "analyticsPage"
> &
  Pick<TableColumnsState, "columnsOrder" | "hideColumn" | "pinColumn" | "reorderVisibleColumns">;

const TableHeadInteractiveColumnActionsDropdown = ({
  column,
  columnsOrder,
  stickyLeft,
  hideColumn,
  pinColumn,
  reorderVisibleColumns,
  analyticsPage,
}: TableHeadInteractiveColumnActionsDropdownProps): ReactElement | null => {
  const showHideAction = column.canHide;
  const showMoveActions = !!reorderVisibleColumns;

  const isFirstColumn = columnsOrder.visible.indexOf(column.id) === 0;
  const canMoveLeft = columnsOrder.visible.indexOf(column.id) > 0;
  const canMoveRight = columnsOrder.visible.indexOf(column.id) < columnsOrder.visible.length - 2;

  const getPinActionText = () => {
    if (!isFirstColumn) return "Pin to start";
    if (stickyLeft) return "Unpin";
    return "Pin";
  };

  return (
    <TableHeadInteractiveColumnOptionsDropdown>
      <DropdownMenuItem
        onAction={() => pinColumn(column.id)}
        analyticsPage={analyticsPage}
        analyticsTitle={COLUMN_CHANGED_ANALYTIC_EVENT}
        analyticsProps={{
          column: column.id,
          action: stickyLeft ? "unpin" : "pin",
        }}
      >
        {getPinActionText()}
      </DropdownMenuItem>

      {showHideAction && (
        <DropdownMenuItem
          onAction={() => hideColumn(column.id)}
          analyticsPage={analyticsPage}
          analyticsTitle={COLUMN_CHANGED_ANALYTIC_EVENT}
          analyticsProps={{ column: column.id, action: "hide" }}
        >
          Hide
        </DropdownMenuItem>
      )}

      {showMoveActions && (
        <>
          <DropdownMenuItem
            onAction={() => reorderVisibleColumns(column.id, "left")}
            isDisabled={!canMoveLeft}
            analyticsPage={analyticsPage}
            analyticsTitle={COLUMN_CHANGED_ANALYTIC_EVENT}
            analyticsProps={{ column: column.id, action: "move left" }}
          >
            Move left
          </DropdownMenuItem>
          <DropdownMenuItem
            onAction={() => reorderVisibleColumns(column.id, "right")}
            isDisabled={!canMoveRight}
            analyticsPage={analyticsPage}
            analyticsTitle={COLUMN_CHANGED_ANALYTIC_EVENT}
            analyticsProps={{ column: column.id, action: "move right" }}
          >
            Move right
          </DropdownMenuItem>
        </>
      )}
    </TableHeadInteractiveColumnOptionsDropdown>
  );
};

TableHeadInteractiveColumnActionsDropdown.displayName =
  "DS.Table.Head.InteractiveColumn.ActionsDropdown";

export default TableHeadInteractiveColumnActionsDropdown;
